import AuthHttpService from "@/common/services/AuthHttpService";
import { EventSource } from "@/common/buses";

export default class MetricsService extends AuthHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  async sendGifView(params: {
    gif: string;
    source: EventSource;
    boosted: boolean;
    username?: string | null;
    position: number;
    fullscreen: boolean;
    pathname: string;
    context?: string | null;
  }): Promise<void> {
    return await this.sendBeacon("gifs", { event: "view", ...params });
  }

  async sendGifPlayback(params: {
    gif: string;
    source: EventSource;
    boosted: boolean;
    play_count: number;
    start_position: number;
    username?: string | null;
    position?: number | null;
    duration?: number;
    pathname: string;
  }): Promise<void> {
    return await this.sendBeacon("gif-playback", params);
  }

  async sendGifShared(params: {
    gif: string;
    source: EventSource;
    boosted: boolean;
    position?: number;
    play_count?: number;
    username?: string | null;
    pathname: string;
  }): Promise<void> {
    return await this.sendBeacon("share-gif", params);
  }

  async sendGifAddedToCollection(params: {
    gif: string;
    source: EventSource;
    boosted: boolean;
    position?: number;
    play_count?: number;
    username?: string | null;
    pathname: string;
  }): Promise<void> {
    return await this.sendBeacon("add-to-collection", params);
  }

  async sendGifLiked(params: {
    gif: string;
    source: EventSource;
    boosted: boolean;
    position?: number;
    play_count?: number;
    username?: string | null;
    pathname: string;
  }): Promise<void> {
    return await this.sendBeacon("like-gif", params);
  }

  async sendProfileClicked(params: {
    gif: string;
    creator: string;
    source: EventSource;
    position?: number;
    play_count?: number;
    username?: string | null;
    pathname: string;
  }): Promise<void> {
    return await this.sendBeacon("click-profile", params);
  }

  async sendUserSubscription(params: {
    gif: string;
    source: EventSource;
    position?: number;
    play_count?: number;
    username?: string | null;
    pathname: string;
  }): Promise<void> {
    return await this.sendBeacon("follow-user", params);
  }

  async sendVisit(username?: string): Promise<void> {
    return await this.beacon("visit", {
      username: username,
    });
  }

  async sendWebVitalsMetrics(params: {
    fcp?: number;
    lcp?: number;
    cls?: number;
    inp?: number;
    ttfb?: number;
    page_group: string;
    device_type: string;
    experiments: string[];
  }): Promise<void> {
    return await this.sendBeacon("web-vitals", params);
  }

  protected async sendBeacon<Response, Params>(action: string, data: Params): Promise<Response | undefined> {
    const session = await this.getSessionId();

    return await this.beacon<Response, Params>(`v2/metrics/${action}`, {
      session,
      ...data,
    });
  }
}
